import type { InstanceStatusEntry } from '@companion-app/shared/Model/InstanceStatus.js'
import { CSpinner } from '@coreui/react'
import { faCheckCircle, faTriangleExclamation, faPowerOff } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { InlineHelp } from '~/Components/InlineHelp.js'
import { observer } from 'mobx-react-lite'

interface InstanceTableStatusCellProps {
	isEnabled: boolean
	status: InstanceStatusEntry | undefined
}
export const InstanceTableStatusCell = observer(function InstanceTableStatusCell({
	isEnabled,
	status,
}: InstanceTableStatusCellProps) {
	if (isEnabled) {
		const messageStr =
			!!status &&
			(typeof status.message === 'string' || typeof status.message === 'number' || !status.message
				? status.message || ''
				: JSON.stringify(status.message))

		switch (status?.category) {
			case 'good':
				return <FontAwesomeIcon icon={faCheckCircle} color={'#33aa33'} size="2xl" />
			case 'warning':
				return (
					<InlineHelp help={`${status.level ?? 'Warning'}${messageStr ? ': ' + messageStr : ''}`}>
						<FontAwesomeIcon icon={faTriangleExclamation} color={'#fab92c'} size="2xl" />
					</InlineHelp>
				)
			case 'error':
				switch (status.level) {
					case 'system':
						return (
							<InlineHelp help={messageStr || 'Unknown error'}>
								<FontAwesomeIcon icon={faTriangleExclamation} color={'#d50215'} size="2xl" />
							</InlineHelp>
						)
					case 'Connecting':
						return (
							<InlineHelp help={`${status.level ?? 'Error'}${messageStr ? ': ' + messageStr : ''}`}>
								<div style={{ padding: '0 3.5px' }}>
									<CSpinner color="warning" style={{ width: '29px', height: '29px' }} />
								</div>
							</InlineHelp>
						)
					default:
						return (
							<InlineHelp help={`${status.level ?? 'Error'}${messageStr ? ': ' + messageStr : ''}`}>
								<FontAwesomeIcon icon={faTriangleExclamation} color={'#d50215'} size="2xl" />
							</InlineHelp>
						)
				}

			default:
				return (
					<InlineHelp help={`Unknown${messageStr ? ': ' + messageStr : ''}`}>
						<FontAwesomeIcon icon={faTriangleExclamation} color={'#fab92c'} size="2xl" />
					</InlineHelp>
				)
		}
	} else {
		return <FontAwesomeIcon icon={faPowerOff} color={'gray'} size="2xl" />
	}
})
